export default __webpack_public_path__ + "static/floor1-slide-4-a3e2758dccaff63491809dfc204785a5.jpg";